import React, { useState } from 'react';
import { FiCheck, FiX, FiDownload, FiRefreshCw } from 'react-icons/fi';

const ResultsSummary = ({ results, type, onReset }) => {
  const { success, failed, errors } = results;
  const [showErrors, setShowErrors] = useState(false);
  const total = success + failed;

  const downloadErrorReport = () => {
    if (errors.length === 0) return;

    const headers = ['Row', 'Error', 'First Name', 'Last Name', 'Address'];
    const csvContent = [
      headers.join(','),
      ...errors.map(error => [
        error.row,
        `"${error.error}"`,
        `"${error.data.firstName || ''}"`,
        `"${error.data.lastName || ''}"`,
        `"${error.data.address || ''}"`
      ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bulk_upload_errors_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="results-summary">
      <div className="summary-header">
        <h3>Upload Complete</h3>
        <div className="summary-stats">
          <div className="stat-card success">
            <FiCheck className="stat-icon" />
            <div className="stat-content">
              <div className="stat-number">{success}</div>
              <div className="stat-label">Successful</div>
            </div>
          </div>

          <div className="stat-card failed">
            <FiX className="stat-icon" />
            <div className="stat-content">
              <div className="stat-number">{failed}</div>
              <div className="stat-label">Failed</div>
            </div>
          </div>

          <div className="stat-card total">
            <div className="stat-content">
              <div className="stat-number">{total}</div>
              <div className="stat-label">Total Processed</div>
            </div>
          </div>
        </div>
      </div>

      <div className="summary-message">
        {success > 0 && failed === 0 && (
          <div className="message success">
            <FiCheck className="message-icon" />
            <span>All {success} {type.toLowerCase()} records were uploaded successfully!</span>
          </div>
        )}

        {success > 0 && failed > 0 && (
          <div className="message partial">
            <span>{success} {type.toLowerCase()} records uploaded successfully, {failed} failed.</span>
          </div>
        )}

        {success === 0 && failed > 0 && (
          <div className="message error">
            <FiX className="message-icon" />
            <span>No records were uploaded successfully. Please check the errors below.</span>
          </div>
        )}
      </div>

      {errors.length > 0 && (
        <div className="error-section">
          <div className="error-header">
            <h4>Upload Errors ({errors.length})</h4>
            <div className="error-actions">
              <button
                className="toggle-errors-btn"
                onClick={() => setShowErrors(!showErrors)}
              >
                {showErrors ? 'Hide Errors' : 'Show Errors'}
              </button>
              <button
                className="download-errors-btn"
                onClick={downloadErrorReport}
              >
                <FiDownload /> Download Error Report
              </button>
            </div>
          </div>

          {showErrors && (
            <div className="error-list">
              {errors.map((error, index) => (
                <div key={index} className="error-item">
                  <div className="error-row">Row {error.row}</div>
                  <div className="error-details">
                    <div className="error-message">{error.error}</div>
                    <div className="error-data">
                      {error.data.firstName} {error.data.lastName}
                      {error.data.address && ` - ${error.data.address}`}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="summary-actions">
        <button className="reset-btn" onClick={onReset}>
          <FiRefreshCw /> Upload Another File
        </button>
      </div>
    </div>
  );
};

export default ResultsSummary;